export default __webpack_public_path__ + "web/react/components/save-for-later-send-to-app-modal/images/s4l-image1.92337e7a3ae3e876d78bf35c364073ed.png";